export default {
    auth: {
        user: null,
        jwt: null,
        error: null
    }
}


// WEBPACK FOOTER //
// ./src/store/state.js